import React, { FC } from 'react'
import Helmet from 'react-helmet'

interface PageTitleProps {
  children: string
}

// TODO: It's only used in Voyage. It should be moved to voyage folder
export const PageTitle: FC<PageTitleProps> = ({ children }) => {
  const isProduction = /avantstay\.com/i.test(window.location.host)

  return (
    <Helmet>
      <title>
        {children ? `${children} - ` : ''}
        AvantStay Voyage
        {isProduction ? '' : ' [DEV VERSION]'}
      </title>
    </Helmet>
  )
}
